import React, {useState, useEffect} from 'react';
import { getCoachLeaderboard } from './helpers/apihandler';


function CoachContest(){

    const [fastestRecords, setFastestRecords] = useState([]);


    

    useEffect(() =>{

        const loadRecords= async () => {

            let recRes =  await getCoachLeaderboard();
            console.log(recRes);
            setFastestRecords(recRes);

        }
        if (fastestRecords.length === 0){
            loadRecords();
        }
        
    })

    

    return(<><h5 style={{textDecoration:'underline'}}>Rookie Coach Contest Leaderboard</h5><div style={{paddingTop:'10px', paddingBottom:'20px'}}>
				<header style={{textDecoration:'underline'}}>
						<div className="col">Coach ID</div>
                        <div className="col">Team</div>
						<div className="col">Reef Points</div>
						<div className="col">Creature</div>
						<div className="col">Phant Skin</div>
				</header>
			{fastestRecords.map(function(coachlist,i) {
				return <div key={i} className="row" style={{backgroundColor:(i % 2 === 0 ? 'rgba(0, 0, 0, 0.4)' : 'unset')}}><div className="col"><a style={{color:'#69cdee'}} target="_blank" rel="noreferrer" href={'https://opensea.io/assets/matic/0x28db8c7721b5765a0cd5617f9f85733115164c3e/' + coachlist.coachid}>{coachlist.coachid}</a></div><div className="col">{coachlist.teamname}</div><div className="col">{coachlist.rps}</div><div className="col">{coachlist.creature}</div><div className="col">{coachlist.skin}</div></div>;
			})}
		
		</div></>)
}


export {CoachContest}